import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CognitoService } from './auth/cognito.service';
import { HeaderComponent } from './core/components/header/header';
import { AiHelpButtonComponent } from './core/components/ai-help-button/ai-help-button.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, AiHelpButtonComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('eve-intelligence-app');
  constructor(private cognitoService: CognitoService) {
    setInterval(
      () => {
        this.cognitoService.isAuthenticated();
      },
      1000 * 60 * 1,
    );
  }
}
